import React, { useState } from 'react';
import axios from './AxiosConfig';
import RedirectForm from './RedirectForm';
import { useNavigate } from 'react-router-dom';
import styles from './styles/Otpform.module.css';
import Timer from './Timer';
import OtpInput from './OtpInput';

const VerifyOtpForm = ({ onNextStep }) => {
    const [otp, setOtp] = useState('');
    const [error, setError] = useState('');
    const [redirectData, setRedirectData] = useState(null);
    const navigate = useNavigate();
    const [limit, setLimit] = useState(0);

    const handleVerifyOtp = async () => {
        if (otp.length < 6) {
            setError("Inserisci un codice OTP completo.");
            return;
        }
        try {
            const response = await axios.post('/api/verify_otp/', { otp_code: otp });
            if (response.data.status === 'success')  {
                    setRedirectData({
                        url: response.data.redirect,
                        session_token: response.data.session_token,
                        user: response.data.user,
                        password: response.data.password,
                    });
                } else {
                    setError(response.data.error || response.data.message || "Errore della risposta");
                    setOtp(''); 
                }
            } 
        catch (error) {
            console.error("Errore durante la verifica dell'OTP:", error);
            setError("Errore durante la verifica dell'OTP.");
            if (error.response && error.response.data) {
        // 👉 qui prendi il messaggio dal backend
                setError(
                    error.response.data.error || 
                    error.response.data.message || 
                    "Errore durante la verifica dell'OTP."
                    );
            } else {
                setError("Errore di connessione al server.");
            }
            setOtp(''); 
        }
    };

    const handleOtpChange = (value) => {
        setOtp(value);
    };
      // 🧹 pulisce messaggio d’errore al click sull’area OTP
    const handleFieldFocus = () => {
        if (error) setError('');
    };
    const handleNavigateToBackup = async () => {
        if (limit === 0) {
            setLimit(1);
            try {
                const response = await axios.post('/api/get_user_email/');
                if (response.data.email_presente) {
                    await axios.get('/api/send_otp_and_redirect/');
                    onNextStep('verify_backup');
                } else {
                    setError("Non hai un'email registrata.");
                }
            } catch (error) {
                console.error("Errore durante l'invio dell'OTP:", error);
                setError("Errore durante l'invio dell'OTP.");
            }
            setLimit(0);
        }
    };
    const handleNavigateToBackupQr = async () => {
        if (limit === 0) {
            setLimit(1);
            try {
                const response = await axios.post('/api/get_user_email/');
                if (response.data.email_presente) {
                    await axios.get('/api/send_otp_and_redirect/');
                    onNextStep('verify_backupQr');
                } else {
                    setError("Non hai un'email registrata.");
                }
            } catch (error) {
                console.error("Errore durante l'invio dell'OTP:", error);
                setError("Errore durante l'invio dell'OTP.");
            }
            setLimit(0);
        }
    };

    const handleSubmit = (event) => {
        event.preventDefault();
        handleVerifyOtp();
    };

    return (
        <div className={`col-4 ${styles.lato_form}`}>
            <Timer/>
            <div className={`p-4 border rounded ${styles.containerloginform}`}>
                <div className={`p-4 border rounded ${styles.containerTesto}`}>
                    <h3 className="mb-4">Verifica OTP</h3>
                </div>
                <div className={styles.messaggioErrore}>
                    {error && <div className="alert alert-danger">{error}</div>}
                </div>
                <div className={styles.login_form}>
                    <form onSubmit={handleSubmit}>
                        <label htmlFor="otpCode">Inserisci il codice OTP dall'app Authenticator:</label>
                        <div onClick={handleFieldFocus}>
                        <OtpInput length={6} value={otp} onOtpChange={handleOtpChange} />
                        </div>
                        <button type="submit" className={`btn btn-primary ${styles.btnVerify}`}>Verifica</button>
                    </form>
                </div>
                <div className={`text-center mt-3 ${styles.backup_Option}`}>
                    <h6>Non hai con te il cellulare?</h6>
                    <h6>Accedi tramite Email</h6>
                    <button onClick={handleNavigateToBackup} className={`btn btn-link ${styles.btnLink}`}>
                        Usa il Codice di Backup
                    </button>
                </div>
                <div className={`text-center mt-3 ${styles.backup_Option}`}>
                    <h6>oppure utilizza un nuovo dispositivo</h6>
                    <button onClick={handleNavigateToBackupQr} className={`btn btn-link ${styles.btnLink}`}>
                        Backup Authenticator
                    </button>
                </div>
                {redirectData && <RedirectForm {...redirectData} />}
            </div>
        </div>
    );
};

export default VerifyOtpForm;
